import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/event.png'


const _withScopeId = n => (_pushScopeId("data-v-268697d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "event"
}, null, -1))
const _hoisted_2 = { class: "inputs" }
const _hoisted_3 = { class: "signup" }
const _hoisted_4 = { class: "onboardingModal" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.3536 3.14645C10.5488 3.34171 10.5488 3.65829 10.3536 3.85355L5.35355 8.85355C5.25979 8.94732 5.13261 9 5 9C4.86739 9 4.74021 8.94732 4.64645 8.85355L2.14645 6.35355C1.95118 6.15829 1.95118 5.84171 2.14645 5.64645C2.34171 5.45118 2.65829 5.45118 2.85355 5.64645L5 7.79289L9.64645 3.14645C9.84171 2.95118 10.1583 2.95118 10.3536 3.14645Z",
  fill: "#5D5E21"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "col" }
const _hoisted_12 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.3536 3.14645C10.5488 3.34171 10.5488 3.65829 10.3536 3.85355L5.35355 8.85355C5.25979 8.94732 5.13261 9 5 9C4.86739 9 4.74021 8.94732 4.64645 8.85355L2.14645 6.35355C1.95118 6.15829 1.95118 5.84171 2.14645 5.64645C2.34171 5.45118 2.65829 5.45118 2.85355 5.64645L5 7.79289L9.64645 3.14645C9.84171 2.95118 10.1583 2.95118 10.3536 3.14645Z",
  fill: "#5D5E21"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "*", -1))
const _hoisted_16 = ["disabled", "loading"]

import { ref, onMounted } from "vue";
import AppToast from "@/utils/appToast";
import passwordEyeCrossed from "@/assets/icons/passwordEyeCrossed.vue";
import passwordEyeOpen from "@/assets/icons/passwordEyeOpen.vue";
import TheModal from "@/components/TheModal.vue";
import Checkbox from "@/assets/icons/checkboxCheck.vue";
import requestProxy from "@/utils/requestProxy";
import { SubmitButton } from "@/utils/designSystem";
import { useRouter } from "vue-router";
import api from "@/utils/api";
import i18n from "@/i18n";



export default /*#__PURE__*/_defineComponent({
  __name: 'SignInView',
  setup(__props) {

const router = useRouter();

const emailInput = ref<HTMLInputElement | null>(null);
const passwordInput = ref<HTMLInputElement | null>(null);
const showPasswordInput = ref(true);
const showPasswordClear = ref(false);
const submitButton = ref<HTMLButtonElement | null>(null);
const isSubmitButtonDisabled = ref(true);
const credentialsErrors = ref({
	email: "",
	password: "",
});
const isLoading = ref(false);
const modalOpen = ref(false);

const businessName = ref(null);

onMounted(() => {
	if (emailInput.value) {
		emailInput.value.value = localStorage.getItem("email") || "";
	}

	emailInput.value?.focus();

	emailInput.value?.addEventListener("input", () => {
		if (emailInput.value && checkEmailFormat(emailInput.value.value)) {
			// show password input
			//showPasswordInput.value = true;
		} else {
			// hide password input
			//showPasswordInput.value = false;
		}

		credentialsErrors.value.email = "";
	});

	passwordInput.value?.addEventListener("input", () => {
		if (passwordInput.value) {
			// enable submit button
			isSubmitButtonDisabled.value = false;
		} else {
			// disable submit button
			isSubmitButtonDisabled.value = true;
		}

		credentialsErrors.value.password = "";
	});
});

const ShowPassword = (state: boolean) => {
	showPasswordClear.value = state;
	if (passwordInput.value)
		passwordInput.value.type = state ? "text" : "password";
};

const submit = (e: Event) => {
	e.preventDefault();

	const email = emailInput.value!.value;
	const password = passwordInput.value!.value;

	isSubmitButtonDisabled.value = true;
	isLoading.value = true;

	requestProxy
		.post("/auth/businessLogin", {
			email,
			password,
		})
		.then((res: any) => {
			isSubmitButtonDisabled.value = false;
			isLoading.value = false;

			localStorage.setItem("userId", res.data.userId);
			localStorage.setItem("idPartner", res.data.idPartner);
			localStorage.setItem(
				"authExpiration",
				(Date.now() + 15 * 60 * 1000).toString()
			);

			if (res.status === 200) {
				if (res.data.firstLaunch) {
					localStorage.setItem("firstLaunch", "true");
					router.push({
						path: "/sign-up",
						state: {
							onboarding: true,
						},
					});
				} else {
					router.push("/profile");
				}
			}
		})
		.catch((res: any) => {
			switch (res.request.status) {
				case 400:
					AppToast.error( i18n.global.t('sign-in.error.400') );
					break;
				case 401:
					AppToast.error(
						i18n.global.t('sign-in.error.401') 
					);
					credentialsErrors.value = {
						email: "Please verify your email",
						password: "Please verify your password",
					};
					break;
				case 403:
					AppToast.error(
						i18n.global.t('sign-in.error.403') 
					);
					break;
				case 404:
					AppToast.error( i18n.global.t('sign-in.error.404') );
					break;
				case 405:
					AppToast.error(
						i18n.global.t('sign-in.error.405') 
					);
					break;
				case 406:
					modalOpen.value = true;
					break;
				case 410:
					AppToast.error( i18n.global.t('sign-in.error.410') );
					break;
				case 500:
					AppToast.error(
						i18n.global.t('sign-in.error.500') 
					);
					break;
				default:
					AppToast.error( i18n.global.t('sign-in.error.default') );
			}

			isSubmitButtonDisabled.value = false;
			isLoading.value = false;
		});
};

const checkEmailFormat = (email: string) => {
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return emailRegex.test(email);
};

// BindPlayerToPartner
const bindPlayerToPartnerModal = ref<typeof TheModal | null>(null);
const updatesCheckboxChecked = ref(false);
const termsCheckboxChecked = ref(false);
const bindPlayerToPartnerSubmitDisabled = ref(true);
const bindPlayerToPartnerSubmitLoading = ref(false);

const onBindPlayerToPartner = async (e: Event) => {
	e.preventDefault();

	if (!businessName.value) {
		AppToast.error("Please enter a business name");
		return;
	}

	const response = await api.postBindPlayerToPartnerCreation({
		email: emailInput.value!.value,
		password: passwordInput.value!.value,
		name: businessName.value,
	});

	if (response.success) {
		bindPlayerToPartnerModal.value?.CloseModal();

		// router push with state
		router.push({
			path: "/sign-up",
			force: true,
			state: {
				onboarding: true,
			},
		});
	} else {
		AppToast.error(response.data?.error);

		if (response.status === 406) {
			router.push("/profile");
		}
	}
};

const closeBindPlayerToPartnerModal = (e: Event) => {
	e.preventDefault();
	bindPlayerToPartnerModal.value?.CloseModal();
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("h1", null, _toDisplayString(_unref(i18n).global.t("sign-in.welcome")), 1),
      _createElementVNode("form", { onSubmit: submit }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("input", {
            ref_key: "emailInput",
            ref: emailInput,
            type: "email",
            placeholder: "Email",
            class: _normalizeClass({ error: credentialsErrors.value.email })
          }, null, 2),
          _withDirectives(_createElementVNode("span", null, [
            _createElementVNode("input", {
              ref_key: "passwordInput",
              ref: passwordInput,
              type: "password",
              placeholder: "••••••••",
              class: _normalizeClass({ error: credentialsErrors.value.password })
            }, null, 2),
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (ShowPassword(!showPasswordClear.value))),
              class: "passwordEye"
            }, [
              _withDirectives(_createVNode(passwordEyeOpen, null, null, 512), [
                [_vShow, !showPasswordClear.value]
              ]),
              _withDirectives(_createVNode(passwordEyeCrossed, null, null, 512), [
                [_vShow, showPasswordClear.value]
              ])
            ])
          ], 512), [
            [_vShow, showPasswordInput.value]
          ])
        ]),
        _createVNode(_unref(SubmitButton), {
          ref_key: "submitButton",
          ref: submitButton,
          disabled: isSubmitButtonDisabled.value,
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t("sign-in.sign-in")), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ], 32),
      _createVNode(_component_RouterLink, {
        class: "forgotPassword",
        to: "/forgot-password"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t("sign-in.forgotPassword")), 1)
        ]),
        _: 1
      }),
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode(_toDisplayString(_unref(i18n).global.t("sign-in.noAccount")) + " ", 1),
        _createVNode(_component_RouterLink, { to: "/sign-up" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t("sign-in.sign-up")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(TheModal, {
      title: "Account existing",
      ref_key: "bindPlayerToPartnerModal",
      ref: bindPlayerToPartnerModal,
      show: modalOpen.value,
      "onUpdate:show": _cache[7] || (_cache[7] = (v) => {
			modalOpen.value = v;
		}
			)
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_unref(i18n).global.t("sign-in.alreadyHaveAccount")), 1),
        _createElementVNode("form", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Enter business name",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((businessName).value = $event)),
                onInput: _cache[2] || (_cache[2] = 
								() => {
									bindPlayerToPartnerSubmitDisabled.value =
										!businessName.value;
								}
							)
              }, null, 544), [
                [_vModelText, businessName.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: _normalizeClass(["checkbox", { checked: updatesCheckboxChecked.value }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (
								updatesCheckboxChecked.value = !updatesCheckboxChecked.value
							))
              }, [
                (updatesCheckboxChecked.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("label", {
                for: "terms",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (
								updatesCheckboxChecked.value = !updatesCheckboxChecked.value
							))
              }, _toDisplayString(_unref(i18n).global.t("sign-in.updates")), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(["checkbox", { checked: termsCheckboxChecked.value }]),
                onClick: _cache[5] || (_cache[5] = 
								() => {
									termsCheckboxChecked.value =
										!termsCheckboxChecked.value;
									bindPlayerToPartnerSubmitDisabled.value =
										!termsCheckboxChecked.value;
								}
							)
              }, [
                (termsCheckboxChecked.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_14))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("label", {
                for: "terms",
                onClick: _cache[6] || (_cache[6] = 
								() => {
									termsCheckboxChecked.value =
										!termsCheckboxChecked.value;
									bindPlayerToPartnerSubmitDisabled.value =
										!termsCheckboxChecked.value;
								}
							)
              }, [
                _createTextVNode(_toDisplayString(_unref(i18n).global.t("sign-in.acceptance.accept")) + " ", 1),
                _createVNode(_component_RouterLink, { to: "/terms-of-use" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(i18n).global.t("sign-in.acceptance.TOU")), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t("sign-in.acceptance.and")) + " ", 1),
                _createVNode(_component_RouterLink, { to: "/terms-of-subscription" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(i18n).global.t("sign-in.acceptance.subscription")), 1)
                  ]),
                  _: 1
                }),
                _hoisted_15
              ])
            ])
          ]),
          _createElementVNode("button", {
            type: "submit",
            class: "grey",
            onClick: closeBindPlayerToPartnerModal
          }, _toDisplayString(_unref(i18n).global.t("sign-in.cancel")), 1),
          _createElementVNode("button", {
            type: "submit",
            onClick: onBindPlayerToPartner,
            disabled: bindPlayerToPartnerSubmitDisabled.value,
            loading: bindPlayerToPartnerSubmitLoading.value
          }, _toDisplayString(_unref(i18n).global.t("sign-in.continue")), 9, _hoisted_16)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})